import React, { useEffect, useState } from 'react';
import PropTypes, { any } from 'prop-types';
import AddEventSponsors from './AddEventSponsors';
import styles from './AddEventSponsors.scss';
import { ConfirmActionPopup } from '../../../PopUps';

const AddSponsorTier = ({ clubId, tiers = { tiers: [] }, setTiers, remainingTiers, setRemainingTiers }) => {
    const [showDeleteConfirmPopup, setShowDeleteConfirmPopup] = useState(false);
    const [toDeleteTier, setToDeleteTier] = useState(false);
    const [showDeleteTierIcon, setShowDeleteTierIcon] = useState(false);

    useEffect(() => {
        if (tiers.length > 0) {
            setShowDeleteTierIcon(true);
        } else {
            setShowDeleteTierIcon(false);
        }
    }, [tiers.length]);

    const addTier = () => {
        if (remainingTiers?.length > 0) {
            const updatedRemainingTiers = [...remainingTiers];
            const newTier = updatedRemainingTiers.pop();
            setTiers((prevState) => {
                return {
                    tiers: [...prevState.tiers, newTier],
                };
            });
            setRemainingTiers(updatedRemainingTiers);
        }
    };

    const deleteTier = () => {
        const newOrder = tiers.tiers[tiers.tiers.length - 1].displayOrder;
        const newTier = { ...toDeleteTier, displayOrder: newOrder };
        const updatedRemainingTiers = [...remainingTiers, newTier];
        setRemainingTiers(updatedRemainingTiers);
        const tierId = toDeleteTier.displayOrder;
        const updatedTiers = tiers?.tiers.filter((tier) => tier.displayOrder !== tierId);
        const updatedOrder = updatedTiers.map((tier, i) => {
            return { ...tier, displayOrder: i + 1 };
        });

        setTiers({ tiers: updatedOrder });
        setShowDeleteConfirmPopup(false);
    };

    const orderedTiers = tiers?.tiers?.sort((a, b) => a.displayOrder - b.displayOrder);
    return (
        <div>
            {showDeleteConfirmPopup && (
                <ConfirmActionPopup
                    onCloseClick={() => {
                        setShowDeleteConfirmPopup(false);
                    }}
                    onCtaClick={deleteTier}
                    confirmationTitle={'Delete Tier'}
                    confirmationMessage={'Are you sure?'}
                    data-testid="modal.delete-sponsor-tier"
                />
            )}
            {orderedTiers.map((tier, index) => (
                <div key={tier.displayOrder} className={index !== tiers.length - 1 ? styles.sponsorTierMargin : ''}>
                    <AddEventSponsors
                        clubId={clubId}
                        tier={tier}
                        setTiers={setTiers}
                        updateShowDeleteConfirmPopup={(newState) => setShowDeleteConfirmPopup(newState)}
                        setToDeleteTier={(tier) => setToDeleteTier(tier)}
                        showDeleteTierIcon={showDeleteTierIcon}
                        tiers={tiers}
                    />
                </div>

            ))}
            <div onClick={addTier} disabled={remainingTiers?.length === 0} className={`${styles.addSponsorsBtn}`}>
                <img src={'/img/icons/addSponsorTierIcon.svg'} alt="add sponsor" />
                <span>Add a sponsor tier</span>
            </div>
        </div>
    );
};

AddSponsorTier.propTypes = {
    clubId: PropTypes.number.isRequired,
    tiers: PropTypes.objectOf(any),
    setTiers: PropTypes.func,
    remainingTiers: PropTypes.instanceOf(Array),
    setRemainingTiers: PropTypes.func,
};
AddSponsorTier.defaultProps = {
    tiers: { tiers: [] },
    setTiers: () => { },
    remainingTiers: [],
    setRemainingTiers: () => { },
};
export default AddSponsorTier;
